import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper-users" }
const _hoisted_2 = { class: "above-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCreateEditUser = _resolveComponent("ModalCreateEditUser")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_TableButton = _resolveComponent("TableButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalCreateEditUser, {
      user: _ctx.userSelected,
      roles: _ctx.roles,
      onClose: _ctx.closeInformationUserModal,
      onCreate: _ctx.createUserTransaction,
      onEdit: _ctx.editUserTransaction
    }, null, 8, ["user", "roles", "onClose", "onCreate", "onEdit"]), [
      [_vShow, _ctx.modalInfoUser]
    ]),
    _withDirectives(_createVNode(_component_ModalConfirmation, {
      message: _ctx.confirmMessage,
      onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeConfirmModalAsync(_ctx.deleteUserTransaction))),
      onDeny: _ctx.closeConfirmModalAsync
    }, null, 8, ["message", "onDeny"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Usuarios", -1)),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Crear usuario',
          onClick: _ctx.createNewUser
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("table", null, [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Código"),
            _createElementVNode("th", null, "Nombre empleado"),
            _createElementVNode("th", null, "Nombre de usuario"),
            _createElementVNode("th", null, "Rol"),
            _createElementVNode("th", null, "Precio base"),
            _createElementVNode("th", null, "Editar"),
            _createElementVNode("th", null, "Eliminar")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(user.emplid), 1),
              _createElementVNode("td", null, _toDisplayString(user.name), 1),
              _createElementVNode("td", null, _toDisplayString(user.username), 1),
              _createElementVNode("td", null, _toDisplayString(user.rol.roleName), 1),
              _createElementVNode("td", null, _toDisplayString(user.base_price), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_TableButton, {
                  onClick: ($event: any) => (_ctx.editUserSelected(user)),
                  type: 'Edit'
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_TableButton, {
                  onClick: ($event: any) => (_ctx.selectDeletedUser(user)),
                  type: 'Delete'
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}